import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f4cefc3")

_pushScopeId("data-v-6f4cefc3")
const _hoisted_1 = { class: "autocomplete" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("添加标签")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dynamicTags, (tag) => {
      return (_openBlock(), _createBlock(_component_el_tag, {
        key: tag.id,
        closable: "",
        "disable-transitions": false,
        onClose: ($event: any) => (_ctx.handleClose(tag))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(tag.name), 1)
        ]),
        _: 2
      }, 1032, ["onClose"]))
    }), 128)),
    _createVNode("div", _hoisted_1, [
      ((_ctx.alwaysShowInput || _ctx.inputVisible) && !(_ctx.singleMode && _ctx.dynamicTags.length > 0))
        ? (_openBlock(), _createBlock(_component_el_autocomplete, {
            key: 0,
            class: "margin-top-5 margin-bottom-5",
            size: "small",
            "value-key": "name",
            ref: "saveTagInput",
            modelValue: _ctx.inputValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue = $event)),
            "fetch-suggestions": _ctx.querySearch,
            placeholder: "搜索标签或输入后回车",
            onSelect: _ctx.handleSelect,
            onMousedown: _ctx.loadData,
            onChange: _ctx.handleInputConfirm
          }, null, 8, ["modelValue", "fetch-suggestions", "onSelect", "onMousedown", "onChange"]))
        : _createCommentVNode("", true),
      (!(_ctx.singleMode || _ctx.alwaysShowInput || _ctx.inputVisible))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            class: "button-new-tag",
            size: "small",
            onClick: _ctx.showInput
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
})